import React from "react";

import { Box, Grid, GridItem, Touchable, useScreenSize } from "@telefonica/mistica";
import { observer } from "mobx-react-lite";
import { HeroDataInfo, ScreenResponsive } from "../../components/organisms";
import { strings } from "../../localization";
import ContractItem, { TypeTag } from "../../components/organisms/ContractItem";
import { useNavigateCustom } from "../../hooks";

// TODO: remove this mock data and implement the real data fetching
const mockData = [
	{
		id: "1",
		contractValue: 2146.57,
		date: "2024/03/05",
		type: TypeTag.IN_PROGRESS,
	},
	{
		id: "6",
		contractValue: 2146.57,
		date: "2024/03/05",
		type: TypeTag.FINISH,
	},
	{
		id: "7",
		contractValue: 2146.57,
		date: "2024/03/05",
		type: TypeTag.CANCELED,
	},
	{
		id: "8",
		contractValue: 2146.57,
		date: "2024/03/05",
		type: TypeTag.CANCELED,
	},
];

const { hiring, myHires } = strings.components.buttons;

const ListOfContracts = observer(() => {
	const navigate = useNavigateCustom();
	const { isDesktopOrBigger: isBig } = useScreenSize();

	const handleNavigateDetailContract = (contractId: string): void => {
		navigate("/contract", { state: { contractId } });
	};

	const onHandleGoBack = (): void => {
		navigate(-1);
	};

	return (
		<ScreenResponsive isFullHeight navigationTitle={hiring} onBack={onHandleGoBack}>
			<Box paddingY={isBig ? 40 : 32} paddingX={isBig ? 24 : 16}>
				<Grid columns={isBig ? 4 : 1} justifyItems="center">
					<GridItem columnStart={isBig ? 2 : 1} columnSpan={isBig ? 2 : 1}>
						<Box paddingBottom={isBig ? 40 : 32}>
							<HeroDataInfo	title={myHires} description={""} />
						</Box>

						<Box paddingX={isBig ? 0 : 16} >
							{mockData.map((item) => (
								<Touchable key={item.id} onPress={() => handleNavigateDetailContract(item.id)}>
									<ContractItem date={item.date} type={item.type} contractValue={item.contractValue} />
								</Touchable>
							))}
						</Box>
					</GridItem>
				</Grid>
			</Box>
		</ScreenResponsive>

	);
});

export default ListOfContracts;
